module.exports = __webpack_public_path__ + "static/media/7.89a58d13.svg";